exports.list = {
    path: '/propinsi',
    name: 'propinsi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/propinsi/List.vue"),
}
exports.show = {
    path: '/propinsi/show/:id',
    name: 'propinsi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/propinsi/Show.vue"),
}